import React, { useState } from 'react';
import { Select, SelectItem } from 'carbon-components-react';
import { useCustomMutation } from '@/utils/useCustomMutation';
import { putMethod } from '@/api/common';
import { useClassList } from '@/api/class.service';
import { ConfirmModal } from '@/components/modal/confirm-modal/ConfirmModal.component';

export default function SetGraduatingClassModal({
  isOpen,
  closeModal,
  refreshClasses,
}) {
  const [selectedClassId, setSelectedClassId] = useState('');
  const { isLoading: isClassLoading, allClasses } = useClassList();

  const { trigger, isMutating, error, reset } = useCustomMutation(
    'class/set-graduation-class',
    (url, { arg }) => putMethod(url, arg),
  );

  const handleClose = () => {
    reset();
    setSelectedClassId('');
    closeModal();
  };

  const handleSetGraduatingClass = () => {
    trigger(
      { classId: selectedClassId },
      {
        onSuccess: () => {
          refreshClasses();
          handleClose();
        },
      },
    );
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      closeModal={handleClose}
      title="Set Graduating Class"
      actionText="SET"
      onClick={handleSetGraduatingClass}
      isLoading={isMutating}
      errorMessage={error?.message}
      disabled={!selectedClassId}
      description={
        <div>
          <p className="text-label mb-20 font-normal">
            Select the class that represents the graduating class for the
            school.
          </p>
          {isClassLoading ? (
            <p className="text-14">Loading classes...</p>
          ) : (
            <Select
              id="graduating-class"
              className="f-width"
              labelText="Select Class"
              value={selectedClassId}
              onChange={(e) => setSelectedClassId(e.target.value)}
              disabled={isMutating}
            >
              <SelectItem disabled text="Select a class" value="" />
              {allClasses?.map((item) => (
                <SelectItem
                  key={item.id}
                  text={item.description}
                  value={item.id}
                />
              ))}
            </Select>
          )}
        </div>
      }
    />
  );
}
